<div class="sign-up-form-container" [ngStyle]="{'background': config.background}">
  <h2 [ngStyle]="{'color': config.titleColor}">{{config.title}} </h2>

  <form ngNoForm action=" http://cl.s7.exct.net/subscribe.aspx" method="post" name="subscribeForm">
    <div class="row">
      <input name="thx" type="hidden" value="http://www.thriveindianapolis.com/subscription-confirmation" />

      <input name="err" type="hidden" value="http://www.thriveindianapolis.com/subscription-error" />

      <input name="MID" type="hidden" value="7200606" />

      <input name="Email Type" type="hidden" value="HTML" />

      <input name="SubAction" type="hidden" value="sub" />

      <input name="lid" type="hidden" value="17037" />

      <div class="col-lg-5 offset-lg-1">
        <div><input name="First Name" type="text" placeholder="First Name" /></div>
      </div>
      <div class="col-lg-5">
        <div><input name="Last Name" type="text" placeholder="Last name" /></div>
      </div>
      <div class="col-lg-5 offset-lg-1">
        <div><input name="Zip Code" type="text" placeholder="Zip Code" /></div>
      </div>
      <div class="col-lg-5">
        <div><input name="Email Address" type="text" placeholder="Email Address" /></div>
      </div>
      <div class="col-lg-3 offset-lg-8 button-column">
        <div style="padding: 5px 0 0 0;"><input type="submit" value="Sign Up" /></div>
      </div>
    </div>
  </form>
</div>